import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { ExportSessionsPayload } from '../models/charging-sessions-export.model'
import { Typography } from '@mui/material'

export interface NoDateRangeSelectedExportSessionsDialogProps {
  open: boolean
  onClose: () => void
  place: number
  payload: ExportSessionsPayload
  exportSessions: (payload: ExportSessionsPayload) => void
}

/**
 * Dialog component to inform user that date is not selected and file will contains data from one year.
 * It contains export button and menu with menu items, handle function export file from BE
 * @param - payload for export file as ExportSessionsPayload
 * @param - exportSessions function form export hook
 * @param - all other params that comes from ModalRoot
 */
export const NoDateRangeSelectedExportSessionsDialog: React.VFC<NoDateRangeSelectedExportSessionsDialogProps> = ({
  open,
  place,
  onClose,
  payload,
  exportSessions,
}) => {
  const { t } = useCustomTranslation()

  return (
    <Dialog
      maxWidth={'sm'}
      title={t('emobility.chargingSession.no-date-range-title')}
      onClose={onClose}
      place={place}
      actions={{
        primary: {
          name: t('emobility.chargingSession.export-confirmation'),
          onClick: () => {
            exportSessions(payload)
            onClose()
          },
        },
        secondary: {
          name: t('common.no'),
        },
      }}
    >
      <Typography>{t('emobility.chargingSession.no-date-range-title-content')}</Typography>
    </Dialog>
  )
}
